/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolders = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12.535 2 2 3H22v13h-5v4H2V7h4.535L8 9.198V2zm-5.07 10-2-3H4v11h11v-8zm4-8H10v6h7v6h3V7h-6.535z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFolders as Folders };
